import { Injectable } from '@angular/core';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { Meeting } from '@cds/betting-offer/tags';
import { MeetingModel, RaceDetailsModel } from '@frontend/sports/racing/feature/models';

import { BreadcrumbSlotResolve, BreadcrumbsResolve } from '../../breadcrumbs/breadcrumbs.resolver';
import { getDayOfRace } from '../../horse-racing-shared/helpers';
import { MeetingSwitcherToggleComponent } from '../components/greyhounds/meeting-switcher-toggle/meeting-switcher-toggle.component';

@Injectable()
export class GreyhoundRaceDetailsBreadcrumbsResolver extends BreadcrumbsResolve<MeetingModel> {
    constructor() {
        super();
    }

    protected customResolve(model: MeetingModel): BreadcrumbSlotResolve {
        return {
            component: MeetingSwitcherToggleComponent,
            required: true,
            inputs: this.getInputs(model),
        };
    }

    private isGreyhoundsDetailsModel(model: MeetingModel): model is RaceDetailsModel {
        //TODO any index issue, probably a defect, please investigate, fixture doesn't exist on type
        //@ts-ignore fixture key doesn't exist in Meeting Model, adding expect error to avoid any logic change
        return model && !!model['fixture'];
    }

    private getInputs(model: MeetingModel): { dayOfRace: DayOfRaceDate | undefined; meeting: Meeting | undefined } {
        if (this.isGreyhoundsDetailsModel(model)) {
            return {
                meeting: model.fixture.meeting,
                dayOfRace: getDayOfRace(model.fixture.startDate),
            };
        } else {
            return {
                meeting: model?.fixtures[0]?.meeting,
                dayOfRace: model?.day,
            };
        }
    }
}
